export const API_URL = process.env.NODE_ENV === 'production' ?
    process.env.REACT_APP_BACKEND_PRODUCTION_URL :
    process.env.REACT_APP_BACKEND_DEVELOPMENT_URL;